export const AUDIT_CAMPAIGN_INITIATE = "auditcampaign/initiate"
export const BULK_PAY_HISTORY = "bulkpay/history";
export const BULK_PAY_INITIATE = "bulkpay/initiate";
export const BULK_PAY_APPROVALS = "bulkpay/approvals";
export const CREATE_SUBSCRIPTION = "subscription/create";
export const LIST_SUBSCRIPTIONS = "subscription/list";
export const LIST_ACCESS_FEE_PLANS = "accessfee/list";
export const LIST_SUBSCRIPTION_REQUESTS = "subscription/rule-requests";
export const VIEW_SUBSCRIPTION_REQUEST = "subscription/rule-requests/:id";
export const LIST_BILLING_PLAN_REQUESTS = "accessfee/rule-requests";
export const VIEW_BILLING_PLAN_REQUEST = "accessfee/rule-requests/:id";
export const VIEW_SUBSCRIPTION = "subscription/view/:id";
export const VIEW_ACCESS_FEE_PLAN = "accessfee/view/:id";
export const BULK_CREATE_SUBSCRIPTION = "bulksubscription/create";
export const CREATE_SHIFT = "shift/create";
export const CREATE_SLAB = "slab/create";
export const CREATE_GEO_SLAB = "slab/geo/create";
export const VIEW_SLAB = "slab/view/:id";
export const DUPLICATE_SLAB = "slab/duplicate/:id";
export const INCENTIVE_APPROVAL_REQUESTS = 'incentive-approval-requests';
export const SLAB_APPROVAL_REQUESTS = 'slab-approval-requests';
export const LIST_REDEEMS = "redeem/list";
export const CREATE_REDEEM = "redeem/create";
export const EDIT_REDEEM = "redeem/edit/:id";
export const CREATE_LIMIT_STORE = "limit-store/create";
export const LIST_LIMIT_STORE = "limit-store/list";
export const LIST_LIMIT_APPROVALS = "limit-store/approvals";

